import {AfterViewInit, Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {ThanksElComponent} from "./thanks-el/thanks-el.component";
import {Thanks} from "../../../../../model/thanks";
import {NgClass, NgForOf} from "@angular/common";

@Component({
  selector: 'app-thanks-page',
  imports: [
    ThanksElComponent,
    NgForOf,
    NgClass
  ],
  templateUrl: './thanks-page.component.html',
  styleUrl: './thanks-page.component.scss'
})
export class ThanksPageComponent implements AfterViewInit{
  texts: Thanks[] = [
    {
      title: 'Заголовок',
      text: 'коллективу Северного центра научно-технической информации и библиотек за подбор книг и лично Инне Юрьевне Дымовой за предоставленные исторические материалы'
    },
    {
      title: 'Заголовок',
      text: 'коллективу ГКУ ЯО "Государственный архив Ярославской области" за предоставленные уникальные документы о деятельности железной дороги в годы Великой Отечественной войны '
    },
    {
      title: 'Заголовок',
      text: 'сотрудникам архива службы управления делами железной дороги за предоставленный доступ к уникальным историческим материалам \n'
    },
    {
      title: 'Заголовок',
      text: 'коллективу Сольвычегодского территориального управления железной дороги и лично Галине Семеновне Лавриненко, Ирине Николаевне Яишницыной за помощь в подборе информации \n',
    },
    {
      title: 'Заголовок',
      text: 'директору Северного морского музея Евгению Анатольевичу Тенетову за предоставление уникальных архивных фотографий.',
      border: false
    },
  ];

  @ViewChild('title') titleElement!: ElementRef;
  isHighlighted: boolean = false;

  ngAfterViewInit() {
    this.checkTitlePosition();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkTitlePosition();
  }

  checkTitlePosition() {
    const rect = this.titleElement.nativeElement.getBoundingClientRect();
    const screenHeight = window.innerHeight;


    this.isHighlighted = rect.top < screenHeight / 3;
  }
}
